module.exports = __webpack_public_path__ + "img/icon-boolean.6adb1086.svg";